export default "__VITE_ASSET__BqanNvKp__"